import { LanguageCode } from "../amorg-common";

export function getBrowserLanguage():LanguageCode
{
    let language:LanguageCode = 'en';
    if(navigator.language.toLowerCase().includes('da'))
        language = 'da';
    
    return language;
}